import React from 'react';
import { CommentOutlined } from '@ant-design/icons';
import { Text } from '@clockout-dev/design-elements';
import styles from '../styles/ticket-thread.module.scss';

function TicketThreadEmpty() {
    return (
        <div className={styles.emptyState}>
            <CommentOutlined className={styles.emptyIcon} />
            <Text as="p" className={styles.emptyTitle}>
                No messages yet
            </Text>
            <Text as="p" className={styles.emptySubtitle}>
                Send a reply below to start the conversation.
            </Text>
        </div>
    );
}

export default TicketThreadEmpty;
